"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _messsageBanner = require("./messsage-banner.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MessageBanner = function MessageBanner(_ref) {
  var color = _ref.color,
      message = _ref.message;
  return message ? /*#__PURE__*/_react["default"].createElement(_messsageBanner.Wrapper, {
    backgroundColor: color,
    showOverlay: false,
    variant: "full"
  }, /*#__PURE__*/_react["default"].createElement(_messsageBanner.Message, {
    source: message
  })) : null;
};

MessageBanner.propTypes = {
  color: _propTypes["default"].string,
  message: _propTypes["default"].string
};
MessageBanner.defaultProps = {
  color: 'blue',
  message: null
};
var _default = MessageBanner;
exports["default"] = _default;